// Categories Data for Handmade Haven
// 5 Main Categories: Jewellery, Resin, Essential, Pigments, Moulds

export const categories = [
    {
        id: 'resin',
        name: 'Resin',
        slug: 'resin',
        icon: '🧪',
        description: 'High-quality epoxy and UV resin for art projects',
        image: '/Updated Products Images/2_1 Resin 300gm 300₹ 1.5gm 1100₹ .webp',
        color: '#9c27b0'
    },
    {
        id: 'moulds',
        name: 'Moulds',
        slug: 'moulds',
        icon: '🔲',
        description: 'Silicone moulds for coasters, jewelry, and decor',
        image: '/Updated Products Images/4 inch agate mould 80₹.webp',
        color: '#4caf50'
    },
    {
        id: 'stands',
        name: 'Stands',
        slug: 'stands',
        icon: '📐',
        description: 'Wooden, metal, and hoop stands for displaying art',
        image: '/Updated Products Images/Wooden stand (6inch&7inch  50₹. ) 4inch&5 inch 40₹.   8 & 9 inch 80₹.webp',
        color: '#795548'
    },
    {
        id: 'essential',
        name: 'Essential',
        slug: 'essential',
        icon: '🛠️',
        description: 'Tools, kits, and essentials for resin art',
        image: '/Updated Products Images/Fairy light 30₹.webp',
        color: '#2196f3'
    },
    {
        id: 'jewellery',
        name: 'Jewellery',
        slug: 'jewellery',
        icon: '💍',
        description: 'Handcrafted resin jewelry and bezels',
        image: '/Updated Products Images/Jhumka bezzel 80₹.webp',
        color: '#e91e63'
    },
    {
        id: 'pigments',
        name: 'Pigments',
        slug: 'pigments',
        icon: '🎨',
        description: 'Colors, flakes, and pigments for resin art',
        image: '/Updated Products Images/Pearl colour combo 99₹.webp',
        color: '#ff9800'
    },
    {
        id: 'custom-orders',
        name: 'Custom Orders',
        slug: 'custom-orders',
        icon: '✨',
        description: 'Customized products made exclusively for you',
        image: '/Updated Products Images/New folder (2)/WhatsApp Order/Customized Vinyl Stickers/1.webp',
        color: '#d14c87'
    }
];

// Category mapping for existing products
// Maps old categories to new category slugs
export const categoryMapping = {
    'Resin': 'resin',
    'Moulds': 'moulds',
    'Stands': 'stands',
    'Tools & Accessories': 'essential',
    'Clock Parts': 'essential',
    'Kits': 'essential',
    'Stickers': 'essential',
    'Jewellery': 'jewellery',
    'Accessories': 'essential', // Resin Clutch moves to Essential if not specified, or stay in accessories? Sheet says Resin Clutch is Essential? No, Sheet doesn't explicitly link "Accessories" category but lists "Resin clutch" under Essential column? WAIT. Let me re-read sheet.
    // Sheet Column "Essential" lists "Resin clutch". So yes, Accessories -> Essential.
    'Pigments': 'pigments',
    'Custom Orders': 'custom-orders'
};

// Get category by slug
export const getCategoryBySlug = (slug) => {
    return categories.find(cat => cat.slug === slug);
};

// Get category by name
export const getCategoryByName = (name) => {
    return categories.find(cat => cat.name.toLowerCase() === name.toLowerCase());
};

// Get all category slugs
export const getAllCategorySlugs = () => {
    return categories.map(cat => cat.slug);
};

// Map old category to new category slug
export const mapToNewCategory = (oldCategory) => {
    return categoryMapping[oldCategory] || 'essential';
};
